/** A capability an active app extends, identified by a versioned slug (e.g. `stored_value_authorize@v1`). */
export interface ActiveAppExtendable {
  slug: string;
  [key: string]: unknown;
}

/**
 * An app that is active/installed for the current tenant, as returned by
 * `GET /v2/b2b/apps/activeapps`.
 */
export interface ActiveApp {
  appRefid: string;
  extendables?: ActiveAppExtendable[];
  [key: string]: unknown;
}

/**
 * Extendable slug used to detect the stored value (gift card) app. Slugs are
 * version-tagged (e.g. `stored_value_authorize@v1`), so matching ignores the
 * `@version` suffix.
 */
export const STORED_VALUE_AUTHORIZE_SLUG = 'stored_value_authorize';

/**
 * Extendable slug used to detect the stored-value product **activation**
 * capability. This gates the backoffice "Gift Cards" product-config menu
 * item (DEV-13600) and its settings page (DEV-13071) — a different
 * capability from `STORED_VALUE_AUTHORIZE_SLUG` above, which gates the
 * checkout gift-card **redemption** UI. Slugs are version-tagged (e.g.
 * `stored_value_activate@v1`), so matching ignores the `@version` suffix.
 */
export const STORED_VALUE_ACTIVATE_SLUG = 'stored_value_activate';
